import React from 'react';
import { Row, Col } from 'antd';

import EMDHistoryTimeline from '../../components/emd/EMDHistoryTimeline'
import AssetRepository from '../../components/adms/AssetRepository'
import { makeTimelineData } from '../../utils/emdUtil';

/**
 * Компонента для получения и отображения списка историй EMDHistoryList  
 * с просмотром карточки ЕМД 
 */
class EMDHistoryList extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        this.state = {
            visible: false,             //Отображаемое модальное окно
            loading: false, 			//Флаг загрузки
            action: undefined,          //Полняемое действия для модального окна
        }
        this.onChangeAsset = this.onChangeAsset.bind(this);
    }
    
    componentWillMount() { 
    }

    showModal = (rectd, text) => {
        this.setState({visible: true, action: text, selected: rectd});
    };
    
    handleOk = e => {
        console.log(e);
        this.setState({visible: false});
    };
    
    onChangeAsset(IRI) {
        console.log(`selected:${IRI}`);
        const {onSelected, history} = this.props;
        if (onSelected)
            onSelected (IRI, history);
    }

    render() {
        console.log(this);
        const {assets, lang, IRI} = this.props
        const history = makeTimelineData(assets, lang);
        return (
            <div>
                <Row>
                    <Col className="csi_filters" span={6} style={{}}>
                        <EMDHistoryTimeline selected={IRI} onSelected={this.onChangeAsset} assets={history} />
                    </Col>
                    <Col className="csi_asset_list" span={18} style={{}}>
                        <Row><AssetRepository  {...this.props} /></Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default EMDHistoryList;